import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleNodes, faHeartCircleCheck, faBullseye, faHeartPulse } from "@fortawesome/free-solid-svg-icons";
import NavbarLogo from "../../components/Navbar/csdv2Logo.png";
import img14 from "../../assets/ourkids/WhatsApp Image 2026-03-25 at 7.40.04 PM.jpeg";

const OurMission = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Hero Section */}
      <section className="relative py-32 gradient-bg text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-white" />
        <div className="container mx-auto px-6 text-center relative z-10">

          <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tighter flex flex-col md:flex-row items-center justify-center gap-6">
            <img src={NavbarLogo} alt="Logo" className="hidden md:block md:h-32 w-auto" />
            <span>Our <span className="italic opacity-80">Mission</span></span>
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light opacity-90 leading-relaxed">
            Ensuring every child born with congenital heart disease has a chance to live a healthy life.
          </p>
        </div>
      </section>

      {/* Vision & Mission Cards */}
      <section className="py-20 relative z-20">
        <div className="container mx-auto px-6">
          <div className="grid gap-12">
            <div className="p-12 glass-card bg-white border-none shadow-2xl flex flex-col items-center text-center group hover:-translate-y-4 transition-all">
              <div className="w-20 h-20 bg-brand-red/10 text-brand-red rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform shadow-lg">
                <FontAwesomeIcon icon={faCircleNodes} size="2x" />
              </div>
              <h2 className="text-3xl font-black text-slate-900 mb-6 tracking-tight uppercase">Our Vision & Mission</h2>
              <p className="text-slate-500 text-lg leading-relaxed italic">
                "Ensuring no child dies of a Congenital Heart Defect due to a lack of funds."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Objectives Section */}
      <section className="py-24 bg-white overflow-hidden">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-20 items-center">
            <div className="lg:w-1/2">
              <h2 className="text-4xl font-black text-slate-900 mb-8 tracking-tighter uppercase">How We <span className="text-brand-red">Achieve It</span></h2>
              <div className="space-y-6">
                {[
                  "Rural screening camps to identify CHD early.",
                  "100% financial assistance for life-saving heart surgeries.",
                  "Partnering with top-tier cardiac hospitals.",
                  "Monitoring post-operative recovery & nutritional support.",
                  "Spreading awareness about Congenital Heart Defects."
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-6 p-6 glass rounded-2xl border-slate-100 border hover:bg-brand-beige transition-colors">
                    <div className="flex-none text-brand-red text-xl">
                      <FontAwesomeIcon icon={faCheckCircle} />
                    </div>
                    <p className="text-slate-700 text-lg font-bold">{item}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:w-1/2 relative">
              <div className="absolute -inset-10 bg-brand-red/5 rounded-full blur-[100px]" />
              <img
                src={img14}
                alt="Doctor"
                className="rounded-[3rem] shadow-2xl relative z-10 border-8 border-white scale-95 hover:scale-100 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-32 bg-slate-900 text-white text-center">
        <div className="container mx-auto px-6">
          <div className="w-24 h-24 gradient-bg rounded-3xl flex items-center justify-center text-white mx-auto shadow-2xl mb-12">
            <FontAwesomeIcon icon={faHeartPulse} size="3x" className="animate-pulse" />
          </div>
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter mb-8 max-w-3xl mx-auto leading-tight">
            Help us mend <span className="text-brand-red">one more heart.</span>
          </h2>
          <Link to="/donate-now" className="inline-block px-12 py-5 gradient-bg text-white rounded-full font-black text-xl hover-glow transform hover:scale-105 transition-all shadow-2xl uppercase tracking-tighter">
            Join The Mission
          </Link>
        </div>
      </section>
    </div>
  );
};

export default OurMission;